// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-gKWNt";
var _4 = "title-1O3lk";
var _5 = "footer-3wA_s";
var _6 = "error-1HT3w";
var _7 = "input-2Bvjx";
var _8 = "input_underline-2xgQM";
var _9 = "input_focused-3wNsa";
var _a = "cancel-1pSz7";
var _b = "submit-155yq";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "title", _5 as "footer", _6 as "error", _7 as "input", _8 as "input_underline", _9 as "input_focused", _a as "cancel", _b as "submit" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "title": _4, "footer": _5, "error": _6, "input": _7, "input_underline": _8, "input_focused": _9, "cancel": _a, "submit": _b }
